export default __webpack_public_path__ + "static/media/play.97c13e59.svg";